import type { JSX } from "solid-js";

export type FilterType = "all" | "todo" | "list";

export interface SearchResult {
  type: "todo" | "list";
  id: string;
  text: string | null;
  completed: number | null;
  color: string | null;
  icon: string | null;
  listId: string | null;
}

export interface QuickAction {
  id: string;
  label: string;
  shortcut?: string;
  icon: () => JSX.Element;
  action: () => void;
}

export const FILTER_TYPES: readonly FilterType[] = ["all", "todo", "list"];
